export default __webpack_public_path__ + "static/media/2.12c848e6.jpg";